import { UrlMappingsKeys } from '../../types';
import { legacyBlogUrlChecker } from './checkers/legacy-blog-url-checker';
export var getLegacyUrlSegments = function (urlMappings, url) {
    if (urlMappings === void 0) { urlMappings = { main: [] }; }
    var legacyUrlSegments;
    var legacyUrlCheckers = [
        {
            key: UrlMappingsKeys.BLOG_POST,
            checker: legacyBlogUrlChecker,
        },
    ];
    var isLegacyUrl = legacyUrlCheckers.find(function (_a) {
        var key = _a.key, checker = _a.checker;
        var segments = checker(urlMappings, url);
        legacyUrlSegments = { key: key, segments: checker(urlMappings, url) || {} };
        return Boolean(segments);
    });
    if (isLegacyUrl) {
        return legacyUrlSegments;
    }
};
//# sourceMappingURL=get-legacy-url-segments.js.map